// extracted by mini-css-extract-plugin
export default {"svg":"SellableVsNonSellable_svg__CmUqW","bar":"SellableVsNonSellable_bar__iChw9","cont":"SellableVsNonSellable_cont__8WEhy"};